import React, { useState, useEffect, useContext } from "react";
import { Box, Grid, Button, TextField, IconButton } from "@mui/material";
import { observer } from "mobx-react-lite";
import CloseIcon from "@mui/icons-material/Close";
import { RootStoreContext } from "../../app/store/root";
import { validateEmail, validateNumbers } from "../../app/util/util";
import { ErrorMessages } from "../../app/util/messages";

import { account } from "../../shared/Utils";
import { Acciones, Menu } from "../../app/util/permisos";

import DialogComponent from "../../app/common/DialogComponent";

const initialState = {
  NombreProveedor: undefined,
  Correo: undefined,
  Telefono: undefined,
  NumeroLicencias: 1,
};

const FormProveedores = ({ data, onClose, onFinish }) => {
  const rootStore = useContext(RootStoreContext);
  const { create, update, newCode } = rootStore.proveedorStore;
  const { alertError } = rootStore.alertStore;
  /* UseStates */
  const [disabled, setDisabled] = useState(true);
  const [model, setModel] = useState(initialState);
  const [errors, setErrors] = useState({
    NombreProveedor: false,
    Correo: false,
    Telefono: false,
    NumeroLicencias: false,
  });
  const [messages, setMessages] = useState({
    Correo: undefined,
    Telefono: undefined,
    NombreProveedor: undefined,
    NumeroLicencias: undefined,
  });
  const [title, setTitle] = useState(undefined);

  const [showDialog, setShowDialog] = useState(false);
  const [typeAction, setTypeAction] = useState(undefined);
  const [messageDialog, setMessageDialog] = useState(undefined);
  const [permisosUsuario, setPermisosUsuario] = useState([]);
  /* End UseStates */

  useEffect(() => {
    setTitle(data != null ? "Edición proveedor" : "Registro proveedor");
    if (!data) {
      setModel({ ...model, ...{ NumeroLicencias: 1 } });
    } else {
      setModel({ ...data });
    }
  }, [data]);

  useEffect(() => {
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso === Menu.Proveedores && a.tienePermiso)
    ) {
      console.log("No tengo permisos para la Proveedores");
    } else {
      setPermisosUsuario(account.getPermisosUsuario());
    }
  }, []);

  /* Methods */
  const setValue = (key, value) => {
    setModel({ ...model, ...{ [key]: value } });
    onValidateAcceptButton();
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  const validationEmail = (e) => {
    setValue("Correo", e.target.value);
    if (e.target.value.length > 0) {
      if (validateEmail(e.target.value)) {
        setError("Correo", false);
        setMessage("Correo", "");
      } else {
        setError("Correo", true);
        setMessage("Correo", ErrorMessages.proveedor.EmailFormatIncorrect);
      }
    } else {
      setError("Correo", true);
      setMessage("Correo", ErrorMessages.proveedor.EmailRequired);
    }
    onValidateAcceptButton();
  };
  const clearInitialState = () => {
    initialErrors();
    setModel({ ...initialState });
  };
  const initialErrors = () => {
    setErrors({
      ...errors,
      ...{
        Correo: true,
        Telefono: true,
        NombreProveedor: true,
      },
    });
    setMessages({
      ...messages,
      ...{
        Correo: ErrorMessages.proveedor.EmailRequired,
        Telefono: ErrorMessages.proveedor.PhoneRequired,
        NombreProveedor: ErrorMessages.proveedor.ProveedorRequired,
      },
    });
    onValidateAcceptButton();
  };
  const validateModel = () => {
    const errors = [],
      objMessages = {};

    if (!model.Correo) {
      errors.push("Correo");
      Object.assign(objMessages, {
        Correo: ErrorMessages.proveedor.EmailRequired,
      });
    }
    if (!model.NombreProveedor) {
      errors.push("NombreProveedor");
      Object.assign(objMessages, {
        NombreProveedor: ErrorMessages.proveedor.ProveedorRequired,
      });
    }
    if (!model.Telefono) {
      errors.push("Telefono");
      Object.assign(objMessages, {
        Telefono: ErrorMessages.proveedor.PhoneRequired,
      });
    }
    if (
      !model.NumeroLicencias ||
      parseInt(model.NumeroLicencias) <= 0 ||
      !validateNumbers(model.NumeroLicencias)
    ) {
      errors.push("NumeroLicencias");
      Object.assign(objMessages, {
        NumeroLicencias: ErrorMessages.proveedor.NumberLicensesRequired,
      });
    }

    if (errors.length > 0) {
      const objErrors = {};
      for (const error of errors) {
        Object.assign(objErrors, { [error]: true });
      }
      setErrors({
        ...errors,
        ...objErrors,
      });
      setMessages({
        ...messages,
        ...objMessages,
      });
      alertError("Ingrese la información requerida");
    }

    onValidateAcceptButton();
    return errors.length <= 0;
  };
  const onValidateAcceptButton = () => {
    if (
      !errors.idProveedor &&
      !errors.nombreEmpresaDestino &&
      !errors.tipoPersona &&
      !errors.rfc &&
      !errors.direccion &&
      model.NombreProveedor &&
      model.Correo &&
      model.Telefono &&
      model.NumeroLicencias
    )
      setDisabled(false);
    else setDisabled(true);
  };
  const finishProcess = (data) => {
    if (!data?.IdProveedor) {
      create(data).then(
        (response) => {
          if (!response) {
            onFinish();
          } else {
            const Errors = { ...errors };
            const Messages = { ...messages };
            for (const element of response) {
              if (element.campo.toUpperCase() === "Correo".toUpperCase()) {
                Errors.Correo = true;
                Messages.Correo = element.mensaje;
              }
              if (element.campo.toUpperCase() === "Telefono".toUpperCase()) {
                Errors.Telefono = true;
                Messages.Telefono = element.mensaje;
              }
              if (element.campo.toUpperCase() === "Proveedor".toUpperCase()) {
                Errors.NombreProveedor = true;
                Messages.NombreProveedor = element.mensaje;
              }
            }
            setErrors({ ...Errors });
            setMessages({ ...Messages });
            onValidateAcceptButton();
          }
        },
        (err) => {}
      );
    } else {
      update(data).then(
        (response) => {
          if (!response) {
            onFinish();
          } else {
            const Errors = { ...errors };
            const Messages = { ...messages };
            for (const element of response) {
              if (element.campo.toUpperCase() === "Correo".toUpperCase()) {
                Errors.Correo = true;
                Messages.Correo = element.mensaje;
              }
              if (element.campo.toUpperCase() === "Telefono".toUpperCase()) {
                Errors.Telefono = true;
                Messages.Telefono = element.mensaje;
              }
              if (element.campo.toUpperCase() === "Proveedor".toUpperCase()) {
                Errors.NombreProveedor = true;
                Messages.NombreProveedor = element.mensaje;
              }
              if (
                element.campo.toUpperCase() === "NumeroLicencias".toUpperCase()
              ) {
                Errors.NumeroLicencias = true;
                Messages.NumeroLicencias = element.mensaje;
              }
            }
            setErrors({ ...Errors });
            setMessages({ ...Messages });
            onValidateAcceptButton();
          }
        },
        (err) => {}
      );
    }
  };
  /* End Methods */

  return (
    <div>
      {/* <Grid container justifyContent={"space-between"} bgcolor="primary.main">
        <Grid item xs>
          <Typography variant="h6">{title}</Typography>
        </Grid>

        <Grid item xs>
          <div style={{ position: "relative" }}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              style={{
                position: "absolute",
                top: "-10px",
                right: 8,
                color: "white !important"
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </Grid>
      </Grid> */}

      <Grid container spacing={3} mb={2}>
        <Grid item xs>
          <h2 style={{ fontSize: 14 }}>
            <strong>{title}</strong>
          </h2>
        </Grid>
        <Grid item xs={6} />
        <Grid item xs>
          <div style={{ position: "relative" }}>
            <IconButton
              aria-label="close"
              onClick={() => {
                setTypeAction("close");
                setMessageDialog(
                  data == null
                    ? "¿Esta seguro que desea cerrar esta ventana? Si la cierra no se registrará el proveedor"
                    : "Si cierra esta ventana se perderá la información capturada. ¿Está seguro de que desea continuar?"
                );
                setShowDialog(true);
              }}
              style={{
                position: "absolute",
                top: "-10px",
                right: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </Grid>
      </Grid>
      <Box noValidate component="form">
        <Grid container columnSpacing={2}>
          {/* <Grid item xs={6}>
            <TextField
              size="small"
              disabled
              margin="normal"
              required
              fullWidth
              id="name"
              label="Nombre Empresa"
              name="name"
              defaultValue={"Ternium"}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="proveedor"
              label="Nombre del proveedor"
              name="proveedor"
              inputProps={{ maxLength: 50 }}
              error={errors.NombreProveedor}
              onChange={(e) => {
                setValue("NombreProveedor", e.target.value);
                setError("NombreProveedor", e.target.value.length <= 0);
                setMessage(
                  "NombreProveedor",
                  e.target.value.length <= 0
                    ? ErrorMessages.proveedor.ProveedorRequired
                    : ""
                );
              }}
              helperText={messages.NombreProveedor}
              value={model.NombreProveedor || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo electrónico"
              name="email"
              type="email"
              error={errors.Correo}
              onChange={validationEmail}
              helperText={messages.Correo}
              value={model.Correo || ""}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="phone"
              label="Teléfono"
              name="phone"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.Telefono}
              value={model.Telefono || ""}
              helperText={messages.Telefono}
              onChange={(e) => {
                if (e.target.value.length <= 0) {
                  setValue("Telefono", e.target.value);
                } else if (
                  e.target.value.length <= 10 &&
                  validateNumbers(e.target.value)
                ) {
                  setValue("Telefono", e.target.value);
                }
                setError(
                  "Telefono",
                  e.target.value.length <= 0 || e.target.value.length < 10
                );
                setMessage(
                  "Telefono",
                  e.target.value.length <= 0
                    ? ErrorMessages.proveedor.PhoneRequired
                    : e.target.value.length < 10
                    ? ErrorMessages.proveedor.PhoneLengthIncorrect
                    : ""
                );
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              size="small"
              margin="normal"
              required
              fullWidth
              id="numCuentas"
              label="Número de cuentas"
              name="numCuentas"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.NumeroLicencias}
              onChange={(e) => {
                setValue("NumeroLicencias", e.target.value);
                setError(
                  "NumeroLicencias",
                  e.target.value.length <= 0 ||
                    parseInt(e.target.value) <= 0 ||
                    !validateNumbers(e.target.value)
                );
                setMessage(
                  "NumeroLicencias",
                  e.target.value.length <= 0 ||
                    parseInt(e.target.value) <= 0 ||
                    !validateNumbers(e.target.value)
                    ? ErrorMessages.proveedor.NumberLicensesRequired
                    : ""
                );
              }}
              helperText={messages.NumeroLicencias}
              value={model.NumeroLicencias}
            />
          </Grid>
          {/* <Grid item sm="6">
            <TextField
              size="small"
              margin="normal"
              select
              required
              fullWidth
              id="selectEstatus"
              value={""}
              label="Estatus"
              onChange={() => {}}
            >
              <MenuItem value={1}>Activo</MenuItem>
              <MenuItem value={2}>Inactivo</MenuItem>
            </TextField>
          </Grid> */}
        </Grid>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        mt={2}
      >
        <Button
          type="submit"
          onClick={() => {
            newCode(model?.IdProveedor);
          }}
          variant="contained"
          style={{ marginRight: 10 }}
        >
          Nuevo código
        </Button>
        <Button
          onClick={() => {
            setTypeAction("clear");
            setMessageDialog(
              "Se eliminará toda la información capturada. ¿Está seguro que desea continuar?"
            );
            setShowDialog(true);
          }}
          variant="contained"
          color="secondary"
          sx={{ color: "#fff" }}
        >
          Limpiar
        </Button>
        <Button
          type="submit"
          onClick={() => {
            setTypeAction("continue");
            setMessageDialog(
              data == null
                ? "¿Todos los datos son correctos?"
                : "¿Seguro que quiere guardar estos cambios?"
            );
            setShowDialog(true);
          }}
          variant="contained"
          disabled={disabled}
          style={{ marginLeft: 10 }}
        >
          Aceptar
        </Button>
      </Grid>
      <DialogComponent
        Open={showDialog}
        Message={messageDialog}
        OnClose={() => setShowDialog(false)}
        OnAccept={() => {
          if (typeAction === "clear") {
            clearInitialState();
          } else if (typeAction === "continue") {
            if (validateModel()) {
              finishProcess(model);
            }
          } else if (typeAction === "close") {
            onClose();
          }
          setShowDialog(false);
        }}
      />
    </div>
  );
};

export default observer(FormProveedores);
